import type { LocaleMessageBundle } from '../../types'

export const dashboardMessages: LocaleMessageBundle = {
  vi: {
    'dashboard.title': 'BigSale trung tâm',
    'dashboard.subtitle': 'Chọn chức năng để bắt đầu làm việc',
    'dashboard.confirm_logout_title': 'Xác nhận đăng xuất',
    'dashboard.confirm_logout_message': 'Bạn có chắc chắn muốn đăng xuất khỏi hệ thống không?',
    'dashboard.confirm_logout_cancel': 'Đóng',
    'dashboard.confirm_logout_confirm': 'Đăng xuất',
    'dashboard.navigation.user_info': 'Thông tin tài khoản',
    'dashboard.navigation.settings': 'Cài đặt cá nhân',
    'dashboard.footer.version': 'Phiên bản',
    'dashboard.module.actions.refresh': 'Làm mới',
    'dashboard.module.chart.revenueSummary': 'Doanh thu tổng hợp',
    'dashboard.module.chart.topProducts': 'Top sản phẩm bán chạy',
    'dashboard.module.chart.productsByCategory': 'Mặt hàng theo danh mục sản phẩm',
    'dashboard.module.chart.bestSellingProducts': 'Mặt hàng bán chạy',
    'dashboard.module.chart.totalAmount': 'Tổng số tiền',
    'dashboard.module.chart.quantity': 'Số lượng',
    'dashboard.module.chart.paymentMethods': 'Phương thức thanh toán',
    'dashboard.module.chart.areaRevenue': 'Doanh thu theo khu vực bàn',
    'dashboard.module.chart.tableRevenue': 'Doanh thu theo bàn',
    'dashboard.module.chart.totalRevenueWithTax': 'Tổng doanh thu gồm thuế',
    'dashboard.module.chart.invoiceCount': 'Số hóa đơn',
    'dashboard.module.stats.goodsAmount': 'Tiền hàng',
    'dashboard.module.stats.cancelAmount': 'Hoàn hủy',
    'dashboard.module.stats.discountAmount': 'Giảm giá',
    'dashboard.module.stats.taxFeeAmount': 'Thuế phí',
    'dashboard.module.stats.revenueWithTax': 'Doanh thu gồm thuế',
    'dashboard.module.stats.unfinishedRevenue': 'Doanh thu chưa hoàn tất',
    'dashboard.module.stats.customerCount': 'Số khách',
    'dashboard.module.stats.invoiceCount': 'Số hóa đơn',
    'dashboard.module.stats.itemQuantity': 'Mặt hàng',
    'dashboard.module.stats.revenueOverview': 'Tổng quan doanh thu',
    'dashboard.module.stats.avgItemsPerInvoice': 'TB mặt hàng/ hóa đơn',
    'dashboard.module.stats.avgRevenuePerInvoice': 'TB doanh thu/ hóa đơn',
    'dashboard.module.stats.cashBookReceiptAmount': 'Phiếu thu sổ quỹ',
    'dashboard.module.stats.cashBookPaymentAmount': 'Phiếu chi sổ quỹ',
    'dashboard.module.stats.formula.goodsAmount':
      'Tổng tiền hàng trước giảm giá của các hóa đơn hoàn thành và hóa đơn hủy trong kỳ.',
    'dashboard.module.stats.formula.cancelAmount':
      'Tổng thành tiền của các hóa đơn đã hủy trong kỳ.',
    'dashboard.module.stats.formula.discountAmount':
      'Tổng tiền giảm giá của các hóa đơn hoàn thành trong kỳ.',
    'dashboard.module.stats.formula.taxFeeAmount':
      'Tổng thuế VAT của các hóa đơn hoàn thành trong kỳ.',
    'dashboard.module.stats.formula.revenueWithTax':
      'Doanh thu hóa đơn hoàn thành + Phiếu thu sổ quỹ − Phiếu chi sổ quỹ.',
    'dashboard.module.stats.formula.cashBookReceiptAmount':
      'Tổng giá trị các phiếu thu sổ quỹ trong kỳ.',
    'dashboard.module.stats.formula.cashBookPaymentAmount':
      'Tổng giá trị các phiếu chi sổ quỹ trong kỳ.',
    'dashboard.module.stats.formula.invoiceCount':
      'Số hóa đơn hoàn thành + Số hóa đơn đã hủy trong kỳ.',
    'dashboard.module.stats.formula.avgItemsPerInvoice':
      'Tổng số lượng mặt hàng đã bán ÷ Số hóa đơn hoàn thành.',
    'dashboard.module.stats.formula.avgRevenuePerInvoice':
      'Tổng thành tiền của hóa đơn hoàn thành ÷ Số hóa đơn hoàn thành.',
    'dashboard.module.stats.formula.unfinishedRevenue':
      'Tiền bàn và tiền hàng đang phát sinh − Phần đã thanh toán − Giảm giá chưa phân bổ.',
    'dashboard.module.table.topProducts': 'Top sản phẩm',
    'dashboard.module.table.product': 'Sản phẩm',
    'dashboard.module.table.quantity': 'SL',
    'dashboard.module.table.revenue': 'Doanh thu',
    'dashboard.module.table.topCustomers': 'Top khách hàng',
    'dashboard.module.table.customer': 'Khách hàng',
    'dashboard.module.table.orders': 'Đơn',
    'dashboard.module.table.spending': 'Chi tiêu',
    'dashboard.module.table.staffRevenue': 'Doanh thu nhân viên',
    'dashboard.module.table.staffName': 'Tên nhân viên',
    'dashboard.module.table.amount': 'Số tiền',
    'dashboard.module.table.total_revenue': 'Doanh thu bán hàng',
    'dashboard.revenueReport.stats.invoiceCount': 'Tổng số hóa đơn',
    'dashboard.revenueReport.stats.cancelledInvoiceCount': 'Số hóa đơn hủy',
    'dashboard.revenueReport.stats.itemQuantity': 'Số lượng mặt hàng',
    'dashboard.revenueReport.stats.avgItemsPerInvoice': 'TB mặt hàng/ HĐ',
    'dashboard.revenueReport.stats.avgRevenuePerInvoice': 'TB doanh thu/ HĐ',
    'dashboard.revenueReport.chart.averageHourlyTitle': 'Doanh thu bán hàng trung bình theo giờ',
    'dashboard.revenueReport.chart.revenueWithTax': 'Doanh thu gồm thuế',
    'dashboard.revenueReport.chart.averageHourlyFormula':
      '*Doanh thu bán hàng trung bình theo giờ = Tổng doanh thu trong một giờ / Tổng số ngày trong kỳ',
    'dashboard.revenueReport.table.weekday': 'Thứ',
    'dashboard.revenueReport.table.date': 'Ngày',
    'dashboard.revenueReport.table.goodsAmount': 'Tiền hàng',
    'dashboard.revenueReport.table.cancelledAmount': 'Tiền hủy',
    'dashboard.revenueReport.table.refundAmount': 'Tiền hoàn',
    'dashboard.revenueReport.table.discountAmount': 'Giảm giá',
    'dashboard.revenueReport.table.taxAmount': 'Thuế',
    'dashboard.revenueReport.table.cashBookReceipt': 'Phiếu thu',
    'dashboard.revenueReport.table.cashBookPayment': 'Phiếu chi',
    'dashboard.revenueReport.table.serviceFee': 'Phí dịch vụ',
    'dashboard.revenueReport.table.shippingFee': 'Phí GH',
    'dashboard.revenueReport.table.partnerReturnAmount': 'Tiền trả ĐTGH',
    'dashboard.revenueReport.table.rentalCollectedAmount': 'Tiền thuê ĐT thu hộ',
    'dashboard.revenueReport.table.tipsAmount': 'Tips',
    'dashboard.revenueReport.table.customerDebt': 'Công nợ KH',
    'dashboard.revenueReport.table.actualCollected': 'Thực thu',
    'dashboard.revenueReport.table.debtCollected': 'Thu nợ',
    'dashboard.revenueReport.table.purchasePaid': 'Nhập hàng',
    'dashboard.revenueReport.table.purchaseDebt': 'Nợ NCC',
    'dashboard.revenueReport.table.revenue': 'Doanh thu',
    'dashboard.revenueReport.table.revenueWithTax': 'Doanh thu gồm thuế',
    'dashboard.revenueReport.table.totalAmount': 'Tổng tiền',
    'dashboard.revenueReport.table.profit': 'Lợi nhuận',
    'dashboard.revenueReport.table.total': 'Tổng cộng',
    'dashboard.revenueReport.actions.exportExcel': 'Xuất Excel',
    'dashboard.financeReport.table.index': 'STT',
    'dashboard.financeReport.table.name': 'Tài chính tổng hợp',
    'dashboard.financeReport.table.currentPeriod': 'Kỳ hiện tại',
    'dashboard.financeReport.rows.salesRevenue': 'DOANH THU BÁN HÀNG',
    'dashboard.financeReport.rows.goodsAmount': 'Tiền hàng',
    'dashboard.financeReport.rows.tax': 'Thuế',
    'dashboard.financeReport.rows.revenueDeductions': 'GIẢM TRỪ DOANH THU',
    'dashboard.financeReport.rows.revenueDeduction': 'Giảm giá hóa đơn',
    'dashboard.financeReport.rows.refundRevenue': 'Doanh thu hoàn',
    'dashboard.financeReport.rows.netRevenue': 'DOANH THU THUẦN',
    'dashboard.financeReport.rows.costs': 'CHI PHÍ',
    'dashboard.financeReport.rows.purchaseCosts': 'Chi phí nhập hàng',
    'dashboard.financeReport.purchaseItem.quantity': 'SL: {quantity} {unit}',
    'dashboard.financeReport.rows.profitBeforeTax': 'LỢI NHUẬN TRƯỚC THUẾ',
    'dashboard.financeReport.rows.cashBookReceipt': 'Phiếu thu',
    'dashboard.financeReport.rows.cashBookPayment': 'Phiếu chi',
    'dashboard.financeReport.rows.shippingRevenue': 'Phí giao hàng khách trả',
    'dashboard.financeReport.rows.purchaseShippingCosts': 'Chi phí vận chuyển nhập hàng',
    'dashboard.financeReport.rows.debtCollected': 'Thu nợ khách hàng',
    'dashboard.financeReport.rows.debtOutstanding': 'Công nợ khách hàng hiện tại',
    'dashboard.financeReport.rows.supplierDebtPayments': 'Trả nợ nhà cung cấp',
    'dashboard.financeReport.rows.supplierDebtOutstanding': 'Công nợ nhà cung cấp cuối kỳ',
    'dashboard.financeReport.formulas.netRevenue': '(C = A - B)',
    'dashboard.financeReport.formulas.profitBeforeTax': '(E = C - D)',
    'dashboard.financeReport.formulas.debtCollected': '(Không cộng lại vào tổng doanh thu)',
    'dashboard.financeReport.formulas.supplierDebtPayments': '(Không cộng lại vào tổng chi phí)',
  },
  en: {
    'dashboard.title': 'BigSale Dashboard',
    'dashboard.subtitle': 'Choose a module to start working',
    'dashboard.confirm_logout_title': 'Confirm Logout',
    'dashboard.confirm_logout_message': 'Are you sure you want to log out of the system?',
    'dashboard.confirm_logout_cancel': 'Cancel',
    'dashboard.confirm_logout_confirm': 'Log Out',
    'dashboard.navigation.user_info': 'Account Information',
    'dashboard.navigation.settings': 'Personal Settings',
    'dashboard.footer.version': 'Version',
    'dashboard.module.actions.refresh': 'Refresh',
    'dashboard.module.chart.revenueSummary': 'Revenue summary',
    'dashboard.module.chart.topProducts': 'Top selling products',
    'dashboard.module.chart.productsByCategory': 'Items by product category',
    'dashboard.module.chart.bestSellingProducts': 'Best-selling items',
    'dashboard.module.chart.totalAmount': 'Total amount',
    'dashboard.module.chart.quantity': 'Quantity',
    'dashboard.module.chart.paymentMethods': 'Payment methods',
    'dashboard.module.chart.areaRevenue': 'Revenue by table area',
    'dashboard.module.chart.tableRevenue': 'Revenue by table',
    'dashboard.module.chart.totalRevenueWithTax': 'Total revenue incl. tax',
    'dashboard.module.chart.invoiceCount': 'Invoice count',
    'dashboard.module.stats.goodsAmount': 'Goods amount',
    'dashboard.module.stats.cancelAmount': 'Refunds / cancellations',
    'dashboard.module.stats.discountAmount': 'Discounts',
    'dashboard.module.stats.taxFeeAmount': 'Taxes and fees',
    'dashboard.module.stats.revenueWithTax': 'Revenue incl. tax',
    'dashboard.module.stats.unfinishedRevenue': 'Unfinished revenue',
    'dashboard.module.stats.customerCount': 'Customer count',
    'dashboard.module.stats.invoiceCount': 'Invoice count',
    'dashboard.module.stats.itemQuantity': 'Items',
    'dashboard.module.stats.revenueOverview': 'Revenue overview',
    'dashboard.module.stats.avgItemsPerInvoice': 'Avg items / invoice',
    'dashboard.module.stats.avgRevenuePerInvoice': 'Avg revenue / invoice',
    'dashboard.module.stats.cashBookReceiptAmount': 'Cash-book receipts',
    'dashboard.module.stats.cashBookPaymentAmount': 'Cash-book payments',
    'dashboard.module.stats.formula.goodsAmount':
      'Subtotal before discounts for completed and cancelled invoices in the period.',
    'dashboard.module.stats.formula.cancelAmount':
      'Total amount of cancelled invoices in the period.',
    'dashboard.module.stats.formula.discountAmount':
      'Total discounts on completed invoices in the period.',
    'dashboard.module.stats.formula.taxFeeAmount':
      'Total VAT on completed invoices in the period.',
    'dashboard.module.stats.formula.revenueWithTax':
      'Completed invoice revenue + Cash-book receipts − Cash-book payments.',
    'dashboard.module.stats.formula.cashBookReceiptAmount':
      'Total value of cash-book receipts in the period.',
    'dashboard.module.stats.formula.cashBookPaymentAmount':
      'Total value of cash-book payments in the period.',
    'dashboard.module.stats.formula.invoiceCount':
      'Completed invoice count + Cancelled invoice count in the period.',
    'dashboard.module.stats.formula.avgItemsPerInvoice':
      'Total sold item quantity ÷ Completed invoice count.',
    'dashboard.module.stats.formula.avgRevenuePerInvoice':
      'Total amount of completed invoices ÷ Completed invoice count.',
    'dashboard.module.stats.formula.unfinishedRevenue':
      'Active table and item charges − Amount already settled − Unallocated discounts.',
    'dashboard.module.table.topProducts': 'Top products',
    'dashboard.module.table.product': 'Product',
    'dashboard.module.table.quantity': 'Qty',
    'dashboard.module.table.revenue': 'Revenue',
    'dashboard.module.table.topCustomers': 'Top customers',
    'dashboard.module.table.customer': 'Customer',
    'dashboard.module.table.orders': 'Orders',
    'dashboard.module.table.spending': 'Spending',
    'dashboard.module.table.staffRevenue': 'Staff revenue',
    'dashboard.module.table.staffName': 'Staff name',
    'dashboard.module.table.amount': 'Amount',
    'dashboard.module.table.total_revenue': 'Total revenue',
    'dashboard.revenueReport.stats.invoiceCount': 'Total invoices',
    'dashboard.revenueReport.stats.cancelledInvoiceCount': 'Cancelled invoices',
    'dashboard.revenueReport.stats.itemQuantity': 'Item quantity',
    'dashboard.revenueReport.stats.avgItemsPerInvoice': 'Avg items / invoice',
    'dashboard.revenueReport.stats.avgRevenuePerInvoice': 'Avg revenue / invoice',
    'dashboard.revenueReport.chart.averageHourlyTitle': 'Average sales revenue by hour',
    'dashboard.revenueReport.chart.revenueWithTax': 'Revenue incl. tax',
    'dashboard.revenueReport.chart.averageHourlyFormula':
      '*Average sales revenue by hour = Total revenue in one hour / Total days in selected period',
    'dashboard.revenueReport.table.weekday': 'Day',
    'dashboard.revenueReport.table.date': 'Date',
    'dashboard.revenueReport.table.goodsAmount': 'Goods amount',
    'dashboard.revenueReport.table.cancelledAmount': 'Cancelled amount',
    'dashboard.revenueReport.table.refundAmount': 'Refund amount',
    'dashboard.revenueReport.table.discountAmount': 'Discount',
    'dashboard.revenueReport.table.taxAmount': 'Tax',
    'dashboard.revenueReport.table.cashBookReceipt': 'Cash-book receipts',
    'dashboard.revenueReport.table.cashBookPayment': 'Cash-book payments',
    'dashboard.revenueReport.table.serviceFee': 'Service fee',
    'dashboard.revenueReport.table.shippingFee': 'Shipping fee',
    'dashboard.revenueReport.table.partnerReturnAmount': 'Partner return amount',
    'dashboard.revenueReport.table.rentalCollectedAmount': 'Rental collected amount',
    'dashboard.revenueReport.table.tipsAmount': 'Tips',
    'dashboard.revenueReport.table.customerDebt': 'Customer debt',
    'dashboard.revenueReport.table.actualCollected': 'Collected at sale',
    'dashboard.revenueReport.table.debtCollected': 'Debt collected',
    'dashboard.revenueReport.table.purchasePaid': 'Purchases paid',
    'dashboard.revenueReport.table.purchaseDebt': 'Purchase debt',
    'dashboard.revenueReport.table.revenue': 'Revenue',
    'dashboard.revenueReport.table.revenueWithTax': 'Revenue incl. tax',
    'dashboard.revenueReport.table.totalAmount': 'Total amount',
    'dashboard.revenueReport.table.profit': 'Profit',
    'dashboard.revenueReport.table.total': 'Total',
    'dashboard.revenueReport.actions.exportExcel': 'Export Excel',
    'dashboard.financeReport.table.index': 'No.',
    'dashboard.financeReport.table.name': 'Consolidated finance',
    'dashboard.financeReport.table.currentPeriod': 'Current period',
    'dashboard.financeReport.rows.salesRevenue': 'SALES REVENUE',
    'dashboard.financeReport.rows.goodsAmount': 'Goods amount',
    'dashboard.financeReport.rows.tax': 'Tax',
    'dashboard.financeReport.rows.revenueDeductions': 'REVENUE DEDUCTIONS',
    'dashboard.financeReport.rows.revenueDeduction': 'Invoice discount',
    'dashboard.financeReport.rows.refundRevenue': 'Refund revenue',
    'dashboard.financeReport.rows.netRevenue': 'NET REVENUE',
    'dashboard.financeReport.rows.costs': 'COSTS',
    'dashboard.financeReport.rows.purchaseCosts': 'Purchase costs',
    'dashboard.financeReport.purchaseItem.quantity': 'Qty: {quantity} {unit}',
    'dashboard.financeReport.rows.profitBeforeTax': 'PROFIT BEFORE TAX',
    'dashboard.financeReport.rows.cashBookReceipt': 'Receipts',
    'dashboard.financeReport.rows.cashBookPayment': 'Payments',
    'dashboard.financeReport.rows.shippingRevenue': 'Customer-paid shipping revenue',
    'dashboard.financeReport.rows.purchaseShippingCosts': 'Purchase shipping costs',
    'dashboard.financeReport.rows.debtCollected': 'Customer debt collected',
    'dashboard.financeReport.rows.debtOutstanding': 'Current customer debt',
    'dashboard.financeReport.rows.supplierDebtPayments': 'Supplier debt payments',
    'dashboard.financeReport.rows.supplierDebtOutstanding': 'Supplier debt at period end',
    'dashboard.financeReport.formulas.netRevenue': '(C = A - B)',
    'dashboard.financeReport.formulas.profitBeforeTax': '(E = C - D)',
    'dashboard.financeReport.formulas.debtCollected': '(Not added again to total revenue)',
    'dashboard.financeReport.formulas.supplierDebtPayments': '(Not added again to total costs)',
  },
}
